export default __webpack_public_path__ + "static/media/favicon.3d20b96a.ico";